import * as React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import CircularProgress from '@mui/material/CircularProgress';
import { GroupChip } from '../../Groups/GroupBadge';
import './styles.css';

import api from '../../../api'
import { getSession } from '../../../auth'

let timeoutId

export default function GroupAutocomplete({ allGroups, onChange, selectedGroup, disablePortal=false, multiple=false, customLabel=null, ...props }) {
  
  const [open, setOpen] = React.useState(false);
  const [options, setOptions] = React.useState(selectedGroup);
  const [nextPage, setNextPage] = React.useState()
  
  const loading = open && options.length === 0;

  const getGroups = (search, groupsUrl) => {

    if (groupsUrl === undefined || (typeof search !== 'object' && search !== undefined)) {
      setOpen(true)
      setOptions([])
    } else setOpen(true)

    const enterpriseId = getSession().profile.enterprise.id

    let url
    if (groupsUrl !== undefined)
      url = `/api/${groupsUrl.split('/api/')[1]}`
    else {
      url = `/api/enterprises/${enterpriseId}/contact_group/noserialize/`
      if (typeof search !== 'object' && search !== undefined)
        url = `${url}?search=${search}`   
    }

    api.get(url).then((res) => {
      if (res.status === 200)
        setOptions((prevOptions) => [...prevOptions, ...res.data.results])
        setNextPage(res.data.next)
    }).catch((err) => {})
  }

  const handleScroll = (event) => {
    const { scrollTop, scrollHeight, clientHeight } = event.target;
    if (nextPage && scrollHeight - scrollTop <= clientHeight + 5)
      getGroups(undefined, nextPage)
  }

  return (
    <Autocomplete
      multiple={multiple}
      size="small"
      className='groups-autocomplete'
      sx={{ padding: "1rem" }}
      open={open}
      disablePortal={disablePortal}
      onOpen={() => getGroups()}
      onClose={() => setOpen(false)}
      isOptionEqualToValue={(option, value) => option.name === value.name}
      getOptionLabel={(option) => option.name}
      options={options}
      loading={loading}
      //filterOptions={(x) => x}
      onInputChange={(event) => {
        if (event?.type === 'change') {
          if (timeoutId)
            clearTimeout(timeoutId)
          timeoutId = setTimeout(() => getGroups(event.target.value), 1000)
        }
      }}
      onChange={(event, group) => onChange(group)}
      ListboxProps={{ onScroll: handleScroll }}
      value={selectedGroup}
      renderTags={(value, getTagProps) => {
        
        const sorted = [...value].sort((a, b) => (a.isEnterprise === b.isEnterprise) ? 0 : (a.isEnterprise ? 1 : -1));
        return sorted.map((option) => {
          const enterprise = option.isEnterprise;
          const originalIndex = value.findIndex(v => v === option);
          const tagProps = getTagProps({ index: originalIndex });
          const onDelete = enterprise ? undefined : tagProps.onDelete;
          return (
            <GroupChip
              {...tagProps}
              label={option.name}
              onDelete={onDelete}
              deleteIcon={enterprise ? null : tagProps.deleteIcon}
              isEnterprise={enterprise}
            />
          )
        })
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={customLabel || "Buscar Segmentos"}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <React.Fragment>
                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </React.Fragment>
            ),
          }}
        />
      )}
      {...props}
    />
  );
}
